const constants = {
  ERROR_CODES: {
    INVALID_PIN: 30027,
  },
  APP_STORE_URLS: {
    IOS: "https://apps.apple.com/app/apple-store/id1533593665",
    ANDROID: "https://play.google.com/store/apps/details?id=com.afriendliercompany.afcbeta",
  }
};

export default constants;